import { useState } from 'react';
import { SEARCH_CONFIG } from '../utils/reportConstants';
import treatmentReportsService from '../../../services/treatmentReportsService';

export const useCustomerSearch = (getFranchiseeId, updateFormField) => {
  const [customerSearch, setCustomerSearch] = useState('');
  const [customerResults, setCustomerResults] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);

  // Search customers
  const searchCustomers = async (query) => {
    if (query.length < SEARCH_CONFIG.CUSTOMER_MIN_LENGTH) {
      setCustomerResults([]);
      setShowCustomerDropdown(false);
      return;
    }

    const franchiseeId = getFranchiseeId();
    if (!franchiseeId) return;

    try {
      const response = await treatmentReportsService.searchCustomers(franchiseeId, query);
      if (response.customers) {
        setCustomerResults(response.customers);
        setShowCustomerDropdown(true);
      }
    } catch (error) {
      console.error('Error searching customers:', error);
    }
  };

  // Handle customer selection - prefill treatment contact from customer
  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
    updateFormField('customer_id', customer.id);
    updateFormField('treatment_contact_name', customer.name || '');
    updateFormField('treatment_contact_company', customer.company_name || '');
    updateFormField('treatment_contact_email', customer.email || '');
    updateFormField('treatment_contact_phone', customer.phone || '');
    // Prefill treatment address from customer
    if (customer.address_line1) {
      updateFormField('treatment_address_line1', customer.address_line1 || '');
      updateFormField('treatment_address_line2', customer.address_line2 || '');
      updateFormField('treatment_address_city', customer.address_city || '');
      updateFormField('treatment_address_state', customer.address_county || '');
      updateFormField('treatment_address_postcode', customer.address_postcode || '');
      updateFormField('treatment_address_country', customer.address_country || 'United Kingdom');
    }
    setCustomerSearch('');
    setCustomerResults([]);
    setShowCustomerDropdown(false);
  };

  // Clear customer selection
  const clearCustomerSelection = () => {
    setSelectedCustomer(null);
    updateFormField('customer_id', '');
    updateFormField('treatment_contact_name', '');
    updateFormField('treatment_contact_company', '');
    updateFormField('treatment_contact_email', '');
    updateFormField('treatment_contact_phone', '');
  };

  // Initialize selected customer from report data
  const initializeSelectedCustomer = (report) => {
    if (report && report.customer_name) {
      setSelectedCustomer({
        id: report.customer_id,
        name: report.customer_name,
        email: report.customer_email,
        phone: report.customer_phone,
        address: report.customer_address
      });
    }
  };

  return {
    customerSearch,
    setCustomerSearch,
    customerResults,
    selectedCustomer,
    showCustomerDropdown,
    searchCustomers,
    handleCustomerSelect,
    clearCustomerSelection,
    initializeSelectedCustomer
  };
};